import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

export default {
    firestorePath: '/pools',
    firestoreRefType: 'collection',
    moduleName: 'pools',
    statePropName: 'pools',
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: '%convertTimestamp%', // default
            updated_at: '%convertTimestamp%', // default
        },
    },
    state,
    getters,
    mutations,
    actions
}